import React, { useState } from "react";
import { Select, message, Modal } from "antd";
import api from "../../../../../services/api";
import { isSuperUser } from "../../../../../utils/is-superuser";

const options = [
  "NÃO PAGO",
  "PAGO",
  "PAGO PARCIALMENTE",
  "RENEGOCIAÇÃO",
  "AJUIZADO",
  "SAIU DA BASE 150+",
  "HONRADO",
  "PAGO – Asaas",
  "PAGO – Coop",
];

export const SituationSelect = ({ idParcela, situacao, updateFunction }) => {
  const [selectedValue, setSelectedValue] = useState(situacao);

  const askSave = (value) => {
    const doRequest = (newValue) =>
      api
        .post(`/contratos/parcela/${idParcela}/situacao/`, {
          situacao: newValue,
        })
        .then(() => {
          message.success("Situação alterada com sucesso");
          setSelectedValue(newValue);
          if (typeof updateFunction === "function") {
            updateFunction();
          }
        })
        .catch((err) => {
          console.error(err);
          message.error("Falha ao salvar situação da parcela");
        });

    if (value === null) {
      Modal.confirm({
        title: "Alterar situação",
        content: `Deseja remover a situação da parcela?`,
        onCancel: () => null,
        onOk() {
          return doRequest(null);
        },
      });
      return;
    }

    Modal.confirm({
      title: "Alterar situação",
      content: `Deseja alterar a situação da parcela para "${value}"?`,
      onCancel: () => null,
      onOk() {
        return doRequest(value);
      },
    });
  };

  return (
    <Select
      showSearch
      style={{ width: "100%", minWidth: "150px" }}
      value={selectedValue ? selectedValue : undefined}
      placeholder="Selecione"
      disabled={!isSuperUser()}
      onChange={askSave}
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      <Select.Option value={null}>Selecione</Select.Option>
      {options.map((option) => (
        <Select.Option key={option} value={option}>
          {option}
        </Select.Option>
      ))}
    </Select>
  );
};

// Alias com o nome usado na tabela nova
export const SelectSituacao = ({ parcelaId, situacao, updateFunction }) => (
  <SituationSelect
    idParcela={parcelaId}
    situacao={situacao}
    updateFunction={updateFunction}
  />
);



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/Contrato/SituationSelect/index.jsx